import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUseCase } from '../common/types/solution';

interface UseCaseState {
  solutions: IUseCase;
  loading: boolean;
  error: string | null;
}

const initialState: UseCaseState = {
  solutions: {} as IUseCase,
  loading: false,
  error: null,
};

const useCasesSlice = createSlice({
  name: 'useCases',
  initialState,
  reducers: {
    setUseCases: (state, action: PayloadAction<IUseCase>) => {
      state.solutions = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setUseCaseError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateLibraryDataSources: (state, action: PayloadAction<any[]>) => {
      if (state.solutions && state.solutions.libraryData) {
        state.solutions.libraryData.dataSources = action.payload;
      }
    },
    resetUseCases: () => initialState,
  },
});

export const { setUseCases, setLoading, setUseCaseError, updateLibraryDataSources, resetUseCases } =
  useCasesSlice.actions;

export const selectUseCases = (state: { useCases: UseCaseState }) => state.useCases.solutions;
export const selectUseCasesLoading = (state: { useCases: UseCaseState }) => state.useCases.loading;
export const selectUseCasesError = (state: { useCases: UseCaseState }) => state.useCases.error;
export default useCasesSlice.reducer;
